import { connect } from 'react-redux';
import BrowsboxMenuList from './BrowsboxMenuList';
import { setActiveMenuItem } from '../../actions/menu';

const mapStateToProps = (state) => {
  const {
    menuItems,
    activeMenuItem,
  } = state;
  return {
    menuItems,
    activeMenuItem,
  };
};

const mapDispatchToProps = ({
  setActiveMenuItem,
});

const BrowsboxMenuContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(BrowsboxMenuList);

export { BrowsboxMenuContainer as default };



// WEBPACK FOOTER //
// ./src/components/Browsbox-menu/BrowsboxMenuContainer.js